<template>
    <b-row> 
        <b-card-group class="col-md-6 col-sm-12 " v-for="(item, index) of items" :key="index" >
            <b-card class="shadow-lg my-3">
                <b-row no-gutters>
                    <b-col cols="4">
                        <b-card-img :src="item.imagen" alt="Image" class="mb-5" style="cursor: pointer" @click.prevent="$emit('item-info', item)"></b-card-img>
                    </b-col>
                    <b-col cols="8">
                        <b-card-text>
                            <a  class="item-name" @click.prevent="$emit('item-info', item)">{{item.nombre}}</a> <br>
                            Item: {{item.codigo}} <br>
                            <div v-if="user.tipo_terceros == 1">
                                Disponibilidad Proveedor: 
                                <b v-if="user.isMaster">{{ item.quantity }}</b>
                                <b v-else :class="$getSimpleStockClass(item.quantity)">{{ $getSimpleStockMessage(item.quantity) }}</b>
                            </div>
                            <div>Código de Barras: <strong> {{item.codigo_barras}} </strong> </div>
                            <div v-if="show_supplier_price && user.isMaster">Precio Proveedor con Imp: <strong>$ {{ numberFormat(item.precio_final_prov_imp) }}</strong></div>
                            <div class="pt-5" v-if="item.prices_by_quantity_array.length > 0">
                                <b>Precio por Volumen de Compra:</b>
                                <div v-for="(price, index) in item.prices_by_quantity_array" :key="index">
                                    <ul>
                                        <li>
                                            <b>{{price.minimum_quantity}}</b> unidades: 
                                            <span class="price-item-quantities"> ${{numberFormat(price.precio_final_con_imp)}} </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="producto-agotado" v-if="item.quantity == '0'"><strong>Producto Agotado</strong></div>
                        </b-card-text>
                    </b-col>
                </b-row>
                <template #footer>
                    <Footer :item="item" />
                </template>
            </b-card>
        </b-card-group>
    </b-row>
</template>

<script>
import { mapState} from 'vuex'
import Footer from './Footer.vue'
export default {
    name: "CardItem2",
    props: {
        items: {
            type: Array
        }       
    },
    computed: {
        ...mapState('auth', ['user']),
        ...mapState('configuration', ['background','show_supplier_price']),
        cssVars() {
            return {
                '--border-bottom': this.background
            };
        },
    },
    components: {
        Footer
    },
};

</script>
<style scoped>
.card-img { 
    max-width: 100%; 
    max-height: 150px;
    object-fit: scale-down;
}

.card-text {
    font-size: 14px;
}

.producto-agotado{
    font-size: 18px;
    color: red;
}

.price-size{
    font-size: 18px;
}

.icon-info{
    color: var(--border-bottom);
    cursor: pointer;
}
</style>